<template>
  <button class="multi-line-button primary--text py-2 px-2" @click="onClick">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "MultiLineButton",
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>

<style>
.multi-line-button {
  position: relative;
  width: 100%;
  border: 1px solid;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
}

.multi-line-button::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: var(--v-primary-base);
  opacity: 0;
  transition: opacity 0.2s;
}
.multi-line-button:hover::before,
.multi-line-button:focus::before {
  opacity: 0.08;
}
</style>
